export default __webpack_public_path__ + "static/media/docker-long.307ce497.png";